import React from "react";
import { useParams } from "react-router-dom";
import Blog_Banner from "./blog-banner/Blog_Banner";
import Inner_Description from "./inner-description/Inner_Description";
import Popular_Tags from "./popular-tags/Popular_Tags";
import Conclusion from "./conclusion/Conclusion";
import Explore_Blogs from "./explore-blogs/Explore_Blogs";

const Blog_Inner_Page = () => {

  const { id } = useParams(); 

  return (
    <>
      <Blog_Banner />

      <div className="custom_container">
        <div className="row justify-content-center">

          <div className="col-lg-8 px-4">
            <Inner_Description blogId={id} />
            <Conclusion blogId={id} />
          </div>

          <div className="col-lg-4 px-4">
            <Popular_Tags blogId={id} />
            <Explore_Blogs blogId={id} />
          </div>

        </div>
      </div>
    </>
  );
};

export default Blog_Inner_Page;